import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";

export const highlightList = createApi({
  reducerPath: "highlightList",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Highlights"],
  endpoints: (builder) => ({
    getHighlightData: builder.query({
      query: () => ({
        url: `${Apis.highlight}`,
      }),
      providesTags: ["Highlights"],
      keepUnusedDataFor: 300,
      transformResponse: (res) => res.data,
    }),
  }),
});

export const { useGetHighlightDataQuery } = highlightList;
